import './utils/logger';
import sdkInfo from './sdk-info';
import { collectJsError } from './collect/jserror-collect';
import eventMessage from './components/event-message';
import { setupRequsetProxy } from './http';
import loadscript from './utils/loadscript';
import HB_STATUS from './constant/hb-status';
import EVENT_MSG_TYPE from './constant/event-msg-type';
import xhrRequest from './utils/xhr-request';
import { pathJoin } from './utils/url';
import getConfFromScript from './utils/get-conf-from-script';
import { DEFAULT_SERVER_PATH, SERVER_CONFIG_API } from './constant';
import safeInvoke from './utils/safe-invoke';
import { win } from './global';
import getServerConfig from './utils/get-server-config';
import formatReportPath from './utils/format-report-path';
import ymcHeaderDecode from './utils/ymc-header-decode';
import userActionCollect from 'src/collect/user-action-collect';
import session from './components/session';
import { setTimeoutIdle } from './utils';

const SYNC_TGAP_TIME = 10 * 60 * 1000;
// js资源所在位置
let RES_PATH = '';
// const win = window;
/**
 * 哈勃监控主体对象
 */
class HubbleMonitor {
  status: HB_STATUS;
  gapTime: number;
  config: HBConfig;
  setupStartTime: number;
  reportDataListener: (messages: any[]) => void;
  constructor() {
    const conf = getConfFromScript();
    RES_PATH = conf.jsPath;
    this.status = HB_STATUS.SETUP;
    this.config = {
      onpremise: conf.onpremise === '1',
      autoCollect: conf.autoCollect !== '0',
      tid: conf.tid,
      appid: conf.appid,
      reportHost: conf.reportHost,
      attrs: {},
    };

    this.init();
  }
  get startTime() {
    return sdkInfo.startTime;
  }
  get reportHost() {
    return formatReportPath(this.config?.reportHost);
  }
  init () {
    collectJsError(); // 监听收集JS错误
    setupRequsetProxy(); // 安装异步请求代理
    userActionCollect(); // 开始收集用户行为
    // performanceCollect(); // 性能相关数据收集
    performance.setResourceTimingBufferSize(500);
    const delaySetup = () => {
      setTimeout(() => this.setup(), 500);
    };
    if(document.readyState === 'complete') {
      this.setupStartTime = Date.now();
      delaySetup();
    } else {
      safeInvoke(win, win.addEventListener, 'load', () => {
        this.setupStartTime = Date.now();
        delaySetup();
      });
    }
    hbLogger.debug('Hubble UBA is ready. Waiting for installation enabled.');
    this.status = HB_STATUS.WAIT_RUNNING;
  }
  async setup() {
    const disabledUba = (msg: string) => {
      hbLogger.warn(msg);
      eventMessage.events = [];
      eventMessage.publish = () => {};
      this.status = HB_STATUS.DISABLED;
    };
    if (win._IUAPPREMISESFLAG) {
      this.config.onpremise = true;
    }
    if (!this.config.reportHost && this.config.onpremise) {
      if (win._GPASSHOST_) {
        this.config.reportHost = `${win._GPASSHOST_}${DEFAULT_SERVER_PATH}`;
      } else {
        disabledUba('上报地址reportPath配置缺失！');
        return;
      }
    }
    // tid必须指定, 缺失时将不再接收处理采集数据及其核心逻辑加载
    if(!this.config.tid) {
      disabledUba('Unregistered tid！');
      return;
    }
    this.loadCore();
  }
  autoSyncGapTime() {
    let syncTimer = false;
    let isFirst = true;
    const handle = () => {
      if (isFirst) {
        isFirst = false;
        hbLogger.debug('autoSyncGapTime first!');
      } else if (!syncTimer) {
        syncTimer = true;
        setTimeoutIdle(() => {
          this.syncGapTime().then(() => {
            if (this.status === HB_STATUS.DISABLED) {
              ['click', 'touchend'].forEach(type => {
                safeInvoke(win, win.removeEventListener, type, handle, true);
              });
              hbLogger.debug('autoSyncGapTime remove!');
            }
          });
          setTimeout(() => {
            syncTimer = false;
          }, SYNC_TGAP_TIME);
        });
      }
    };
    ['click', 'touchend'].forEach(type => {
      safeInvoke(win, win.addEventListener, type, handle, true);
    });
  }
  async loadCore() {
    // 请求获取服务配置
    this.syncGapTime().then((ret) => {
      if (!ret.openUba) {
        this.status = HB_STATUS.DISABLED;
      }
      if (RES_PATH) {
        xhrRequest(pathJoin(RES_PATH, `2.x.version?_t=${Date.now()}`)).catch(() => sdkInfo.v).then((ver: string) => {
          let version = String(ver);
          const mats = version.match(/^(\d+)\.\d+\.\d+/);
          if(!mats) {
            version = sdkInfo.v;
          }
          hbLogger.debug(`Loading and installing. index version: ${sdkInfo.v}, core version: ${version}`);
          loadscript(pathJoin(RES_PATH, `uba-core.js?v=${version}`), () => {
            if (this.status === HB_STATUS.WAIT_RUNNING) {
              this.status = HB_STATUS.RUNNING;
            }
            hbLogger.info(`Hubble UBA is ${this.status === HB_STATUS.RUNNING ? 'RUNNING' : 'DISABLED'}.`, version);
            if (this.status === HB_STATUS.RUNNING) {
              this.autoSyncGapTime();
            }
          });
        });
      } else {
        hbLogger.warn('uba资源路径获取失败');
      }
    });
  }
  syncGapTime() {
    return getServerConfig(pathJoin(this.reportHost, SERVER_CONFIG_API)).then((ret) => {
      this.gapTime = ret.time > 0 ? ret.time - Date.now() : -1;
      // hbLogger.debug('syncGapTime!', this.gapTime);
      if (!ret.openUba && this.status === HB_STATUS.RUNNING){
        this.status = HB_STATUS.DISABLED;
      }
      return ret;
    });
  }
  startBizOp(ba: string, timeout = 60000): { end: () => void } {
    let finish: (value?: any) => void;
    const endBizOp = new Promise((resolve) => {
      finish = resolve;
      setTimeout(() => resolve(Date.now()), Math.min(timeout, 5 * 60 * 1000));
    });
    eventMessage.publish({
      time: Date.now(),
      type: EVENT_MSG_TYPE.BIZOP,
      data: { ba, endBizOp },
    });
    return {
      end: () => finish(Date.now())
    };
  }
  report(eventName: string, attrsData: Record<string, unknown>) {
    if(/^HB/.test(eventName)) {
      throw new Error('内置占用，不支持以HB开头命名事件!');
    }
    eventMessage.publish({
      time: Date.now(),
      type: EVENT_MSG_TYPE.CUSTOM,
      isManual: true,
      data: {
        en: eventName,
        attrs: attrsData,
      },
    });
  }
  reportCountEvent(ecid: string, ecbiz?: string) {
    if(ecid) {
      eventMessage.publish({
        time: Date.now(),
        type: EVENT_MSG_TYPE.COUNT,
        isManual: true,
        data: { ecid, ecbiz },
      });
    } else {
      hbLogger.warn('reportCountEvent ecid is required!');
    }
  }
  // 支持BPR录制获取前端数据使用
  addReportDataListener(listener: (messages: any[]) => void) {
    this.reportDataListener = listener;
  }
  removeReportDataListener() {
    this.reportDataListener = null;
  }
  /**
   * 配置方法，可重复调用，相同key配置新旧覆盖逻辑
   * @param cfg 配置数据JSON
   * @param cfg.appid 应用标识
   * @param cfg.attrs 自定义需要上报的数据
   */
  setConfig(cfg: HBConfig) {
    const { attrs, tid, appid, reportHost, getUser, getBizData, requestFilter } = cfg;
    if (!this.config.tid && tid) {
      this.config.tid = tid;
    }
    if (!this.config.appid && appid) {
      this.config.appid = appid;
    }
    if (!this.config.reportHost && reportHost) {
      this.config.reportHost = reportHost;
    }
    if (getUser) {
      this.config.getUser = getUser;
    }
    if (getBizData) {
      this.config.getBizData = getBizData;
    }
    if (requestFilter) {
      this.config.requestFilter = requestFilter;
    }
    if (attrs) {
      Object.assign(this.config.attrs, attrs);
    }
  }
}

if(!win.uba) {
  // 向外暴露的对象
  win.uba = {
    ...sdkInfo,
    ymcHeaderDecode,
    getSid(shouldAutoCreate = false) {
      return shouldAutoCreate ? session.getCurrentSid() : session.getSid();
    },
  };
  const hubbleMonitor = new HubbleMonitor();
  Object.assign(win.uba, {
    isEnabled() {
      return hubbleMonitor.status === HB_STATUS.RUNNING;
    },
    getConfig() {
      return hubbleMonitor.config;
    },
    setConfig: (cfg: HBConfig) => {
      hubbleMonitor.setConfig(cfg);
    },
    setAttrs: (attrs: Record<string, unknown>) => {
      hubbleMonitor.setConfig({ attrs });
    },
    startBizOp: (ba: string, timeout?: number): ({ end: () => void }) => {
      return hubbleMonitor.startBizOp(ba, timeout);
    },
    report: (eventName: string, attrsData: Record<string, unknown>) => {
      hubbleMonitor.report(eventName, attrsData);
    },
    reportCountEvent: (ecid: string, ecbiz?: string) => {
      hubbleMonitor.reportCountEvent(ecid, ecbiz);
    },
    __instance: hubbleMonitor,
  });
} else {
  hbLogger.warn(`当前环境已存在uba实例！`);
}

